import React from 'react';
import {Modal} from 'antd';
import QuestionCircleOutlined from "@ant-design/icons/es/icons/QuestionCircleOutlined";
import {commonLan,setInfoModalVisible,isInfoModalVisible} from "../../source/js/common";
//import * as commonLan from "../../constant/js/formItemNameLabel/en_US/common";
var timer = null
export function aisinoChooseOneDataModal(callBack) {
    return Modal.info({
        title:commonLan.prompt,
        content: commonLan.selectOneRecordTip,
        okText:commonLan.okButton.label,
        onOk:callBack,
        okButtonProps:{
            size:"small"
        }
    });
}
export function aisinoSaveSuccessModal(callBack) {
    return Modal.success({
        title:commonLan.prompt,
        content: commonLan.successfullySaved,
        okText:commonLan.okButton.label,
        onOk:callBack,
        okButtonProps:{
            size:"small"
        }
    });
}
export function aisinoSuccessModal(callBack) {
    return Modal.success({
        title:commonLan.prompt,
        content: commonLan.successfullySubmitted,
        okText:commonLan.okButton.label,
        onOk:callBack,
        okButtonProps:{
            size:"small"
        }
    });
}
export function aisinoSuccessOperatedModal(callBack) {
    return Modal.success({
        title:commonLan.prompt,
        content: commonLan.successfullyOperated,
        okText:commonLan.okButton.label,
        onOk:callBack,
        okButtonProps:{
            size:"small"
        }
    });
}
export function aisinoErrorModal(callBack) {
    return Modal.error({
        title:commonLan.prompt,
        content: commonLan.operationFailedCommon,
        okText:commonLan.okButton.label,
        onOk:callBack,
        okButtonProps:{
            size:"small"
        }
    });
}

export function aisinoInfoModal(content,callBack,title,width) {
    if(isInfoModalVisible()){
        return;
    }
    setInfoModalVisible(true);
    return Modal.info({
        title:title?title:commonLan.prompt,
        content: content,
        okText:commonLan.okButton.label,
        onOk:function(){
            if(callBack){
                callBack()
            }
            setInfoModalVisible(false);
        },
        okButtonProps:{
            size:"small"
        },
        onCancel:function() {
            setInfoModalVisible(false);
        },
        width:width?width:400
    });
}
export function aisinoInfoModalForEx(content,callBack,title) {
    if(isInfoModalVisible()){
        return;
    }
    setInfoModalVisible(true);
    return Modal.info({
        title:title?title:commonLan.prompt,
        content: (
            <div style={{whiteSpace: "pre-wrap"}}>{content}</div>
        ),
        okText:commonLan.okButton.label,
        onOk:function(){
            if(callBack){
                callBack()
            }
            setInfoModalVisible(false);
        },
        onCancel:function() {
            setInfoModalVisible(false);
        },
        okButtonProps:{
            size:"small"
        }
    });
}
export function aisinoCancelConfirmModal(okCallBack) {
    return Modal.confirm({
        title:commonLan.confirmButton.label,
        content: commonLan.cancelConfirm.label,
        okText:commonLan.okButton.label,
        cancelText:commonLan.cancelButton.label,
        onOk:okCallBack,
        icon:<QuestionCircleOutlined />,
        okButtonProps:{
            size:"small"
        },
        cancelButtonProps:{
            size:"small"
        }
    });
}
export function aisinoCancelConfirmModal2(okCallBack) {
    return Modal.confirm({
        title:commonLan.confirmButton.label,
        content: <>
            <iframe style={{border: "none",
                position: "absolute", top: 0, left: 0,
                height: "100%", width: "100%",minHeight:0, zIndex: -1}} src={"about:blank"}/>
            <span>{commonLan.cancelConfirm.label}</span></>,
        okText:commonLan.okButton.label,
        cancelText:commonLan.cancelButton.label,
        onOk:okCallBack,
        icon:<QuestionCircleOutlined />,
        okButtonProps:{
            size:"small"
        },
        cancelButtonProps:{
            size:"small"
        }
    });
}
export function aisinoCloseConfirmModal(okCallBack) {
    return Modal.confirm({
        title:commonLan.confirmButton.label,
        content: commonLan.closeConfirm.label,
        okText:commonLan.okButton.label,
        cancelText:commonLan.cancelButton.label,
        onOk:okCallBack,
        icon:<QuestionCircleOutlined />,
        okButtonProps:{
            size:"small"
        },
        cancelButtonProps:{
            size:"small"
        }
    });
}
export function aisinoSubmitConfirmModal(okCallBack) {
    return Modal.confirm({
        title:commonLan.confirmButton.label,
        content: commonLan.submitConfirm.label,
        okText:commonLan.okButton.label,
        cancelText:commonLan.cancelButton.label,
        onOk:okCallBack,
        icon:<QuestionCircleOutlined />,
        okButtonProps:{
            size:"small"
        },
        cancelButtonProps:{
            size:"small"
        }
    });
}
export function aisinoSaveConfirmModal(okCallBack) {
    return Modal.confirm({
        title:commonLan.confirmButton.label,
        content: commonLan.saveConfirm.label,
        okText:commonLan.okButton.label,
        cancelText:commonLan.cancelButton.label,
        onOk:okCallBack,
        icon:<QuestionCircleOutlined />,
        okButtonProps:{
            size:"small"
        },
        cancelButtonProps:{
            size:"small"
        }
    });
}
export function aisinoConfirmModal(content,title,okCallBack,cancelCallBack) {
    return Modal.confirm({
        title:title?title:commonLan.confirmButton.label,
        content: content,
        okText:commonLan.okButton.label,
        cancelText:commonLan.cancelButton.label,
        onOk:okCallBack,
        onCancel:cancelCallBack,
        autoFocusButton:null,
        icon:<QuestionCircleOutlined />,
        okButtonProps:{
            size:"small"
        },
        cancelButtonProps:{
            size:"small"
        }
    });
}
export function aisinoWarningModal(content,callBack){
    return Modal.warning({
        title:commonLan.prompt,
        content:content,
        okText:commonLan.okButton.label,
        onOk:callBack,
        okButtonProps:{
            size:"small"
        }
    })
}
export function aisinoErrorPromptModal(content,callBack){
    return Modal.error({
        title:commonLan.prompt,
        content:content,
        okText:commonLan.okButton.label,
        onOk:callBack,
        okButtonProps:{
            size:"small"
        }
    })
}
export function showDeleteConfirm(onOk,onCancel) {
    return Modal.confirm({
        title:commonLan.confirmButton.label,
        content: commonLan.deleteConfirmTip.label,
        okText: commonLan.okButton.label,
        cancelText:commonLan.cancelButton.label,
        icon:<QuestionCircleOutlined />,
        onOk,
        onCancel,
        okButtonProps:{
            size:"small"
        },
        cancelButtonProps:{
            size:"small"
        }
    });
  }
  export function ReferenceNoConfirm(onOk,onCancel,content) {
    return Modal.confirm({
        zIndex:999,
        title:commonLan.confirmButton.label,
        content,
        okText: commonLan.confirmButton.label,
        cancelText:commonLan.cancelButton.label,
        icon:<QuestionCircleOutlined />,
        onOk,
        onCancel,
        okButtonProps:{
            size:"small"
        },
        cancelButtonProps:{
            size:"small"
        }
    });
  }

